<template>
  <div class="container">

    <div class="alert alert-danger" v-if="new_offer_is_error==true">
      <p>{{ new_offer_error }}</p>
    </div>
    <div class="alert alert-danger" v-if="is_start_send==1">
      <p>Идет сохранение </p>
    </div>
    <div class="row">
       <div class="col-12">
         <label for="currency">Тип оплаты:</label>
         <select id="currency" class="form-control" v-model="newOffer.type">
           <option :value="'one'">единоразовая</option>
           <option :value="'every_month'">раз в месяц</option>
           <option :value="'every_year'">раз в год</option>
         </select>
       </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label for="amount">Сумма:</label>
        <input type="number" id="amount" v-model="newOffer.price" class="form-control" />


      </div>
      <div class="col-md-4">
        <label for="amount">Сумма предоплаты:</label>
        <input type="number" id="amount" v-model="newOffer.prepaid_price" class="form-control" />
      </div>
      <div class="col-md-4">
        <label for="currency">Выберите валюту:</label>
        <select id="currency" class="form-control" v-model="newOffer.currency">
          <option v-for="(current_currency,currency_index) in type_currencys"
                  :value="current_currency" :key="currency_index">
            {{ current_currency }}
          </option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <label for="date">Выберите дату:</label>
        <input type="date" id="date" class="form-control" v-model="newOffer.date_end" />
      </div>
      <div class="col-md-8">
        <label for="comment">Опишите услугу:</label>
        <textarea id="comment" class="textarea_add_lead form-control" v-model="newOffer.comment"></textarea>
      </div>

    </div>
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-end ">
        <button type="submit" class="btn " @click="submit">Отправить</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormPriceBlock",
  props: {


    is_start_send:Number,
    newOffer:Object,
    new_offer_is_error:Boolean,
    new_offer_error:String,
    type_currencys:Array,



  },
  methods:{
   submit(){
     this.$emit('click_button',this.newOffer);
   }
  }
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
</style>
